var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 16,
    viewBox: "0 0 3 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4C0 13.9757 0.158035 13.5687 0.43934 13.2686C0.720644 12.9686 1.10218 12.8 1.5 12.8C1.89782 12.8 2.27936 12.9686 2.56066 13.2686C2.84196 13.5687 3 13.9757 3 14.4C3 14.8243 2.84196 15.2313 2.56066 15.5314C2.27936 15.8314 1.89782 16 1.5 16C1.10218 16 0.720644 15.8314 0.43934 15.5314C0.158035 15.2313 0 14.8243 0 14.4ZM0 8C0 7.57565 0.158035 7.16869 0.43934 6.86863C0.720644 6.56857 1.10218 6.4 1.5 6.4C1.89782 6.4 2.27936 6.56857 2.56066 6.86863C2.84196 7.16869 3 7.57565 3 8C3 8.42435 2.84196 8.83131 2.56066 9.13137C2.27936 9.43143 1.89782 9.6 1.5 9.6C1.10218 9.6 0.720644 9.43143 0.43934 9.13137C0.158035 8.83131 0 8.42435 0 8ZM0 1.6C0 1.17565 0.158035 0.768687 0.43934 0.468629C0.720644 0.168571 1.10218 0 1.5 0C1.89782 0 2.27936 0.168571 2.56066 0.468629C2.84196 0.768687 3 1.17565 3 1.6C3 2.02435 2.84196 2.43131 2.56066 2.73137C2.27936 3.03143 1.89782 3.2 1.5 3.2C1.10218 3.2 0.720644 3.03143 0.43934 2.73137C0.158035 2.43131 0 2.02435 0 1.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/vector_icon.841019f7e36a918203dfcda0e61212c2.svg";
export { ForwardRef as ReactComponent };